import React, { useState } from 'react';
import { COLORS, Row, toRGBA } from '@cuemath/comps';
import { Text, TextInput } from '@cuemath/web-comps';

import { prePrimaryGrades } from 'constants/constants';

import { slotsInitState } from '.';
import StudentTransferSlotsList from './add-slots';
import { InfoWrapper, LinkText, NameCard, NameCardWrapper, SCRoot } from './styles';
import { EditSlotIcon } from 'screens/student-transfer/styles/transfer-info';

const getSlotPendingData = data => {
  const {
    student_name: studentName,
    teacher_name: teacherName,
    grade,
    region,
    class_balance: classBalance,
    tenure_end_date: tenureEndDate,
  } = data || {};

  return [
    {
      title: 'Student',
      value: studentName,
    },
    {
      title: 'Teacher',
      value: teacherName,
    },
    {
      title: 'Grade',
      value: prePrimaryGrades[grade] || grade,
    },
    {
      title: 'Region',
      value: region,
    },
    {
      title: 'Class Balance',
      value: classBalance,
    },
    {
      title: 'Tenure end date',
      value: tenureEndDate,
    },
  ];
};

const SlotCreationIndex = ({
  updateSlotsList,
  addSlots,
  slotsList,
  setSlotsList,
  data,
  setNewPreferredTeacherId,
  newPreferredTeacherId,
  reasonForTransfer,
}) => {
  const [editTeacherId, setEditTeacherId] = useState(false);
  const showPreferredTeacherInfo = reasonForTransfer === 'PREFERRED_TEACHER';

  const slotCreationData = getSlotPendingData(data);

  const handleEditPreferredTeacherId = () => {
    if (editTeacherId) {
      setNewPreferredTeacherId(prev => ({ ...prev, preferredTeacherId: '' }));
    }
    setEditTeacherId(!editTeacherId);
  };

  return (
    <SCRoot>
      <InfoWrapper>
        {slotCreationData.map(item => {
          const { title, value } = item || {};

          return (
            <NameCardWrapper key={title} alignItems="center" flexDirection="row" nowrap>
              <NameCard variant="eyebrow2" color={toRGBA(COLORS.COLA, 0.75)}>
                {title}
              </NameCard>
              <Text variant="cta1">{value || '-'}</Text>
            </NameCardWrapper>
          );
        })}

        {showPreferredTeacherInfo && (
          <NameCardWrapper alignItems="flex-start" justifyContent="center">
            <Row
              nowrap
              alignItems="center"
              justifyContent="space-between"
              className="gap_8_px"
            >
              <NameCard variant="eyebrow2" color={toRGBA(COLORS.COLA, 0.75)}>
                Preferred teacher id
              </NameCard>

              <EditSlotIcon onClick={handleEditPreferredTeacherId} />
            </Row>
            {data.preferred_teacher_id && (
              <Text variant="body2" weight="600">
                {data.preferred_teacher_id || '-'}
              </Text>
            )}

            {editTeacherId && (
              <TextInput
                value={newPreferredTeacherId}
                width="320px"
                label="Teacher ID"
                onChange={value => setNewPreferredTeacherId(value)}
              />
            )}
          </NameCardWrapper>
        )}
      </InfoWrapper>

      <InfoWrapper gap={8}>
        <Row alignItem="center" justifyContent="space-between">
          <NameCard variant="eyebrow2">Regular Slots (IST)</NameCard>
          <LinkText variant="body1Regular" onClick={() => setSlotsList(slotsInitState)}>
            Reset
          </LinkText>
        </Row>

        {slotsList.map(slotData => {
          return (
            <StudentTransferSlotsList
              key={slotData.id}
              {...slotData}
              updateSlotsList={updateSlotsList}
              slotsList={slotsList}
            />
          );
        })}

        <LinkText variant="body1Regular" onClick={addSlots}>
          Add more
        </LinkText>
      </InfoWrapper>
    </SCRoot>
  );
};

export default SlotCreationIndex;
